import { Controller } from "../../../Controller";
import {
    AtualizarConfigEnvelopeDestinatarioService,
    DeletarConfigEnvelopeDestinatarioService,
    GetConfigEnvelopeDestinatarioService,
    InserirConfigEnvelopeDestinatarioService,
    ListarConfigEnvelopeDestinatarioService,
} from "../../../../Services/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioServices";
import {
    IConfigEnvelopeDestinatario,
    IInserirConfigEnvelopeDestinatario,
} from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioInterfaces";

export async function GetConfigEnvelopeDestinatarioController(
    idConfigEnvelopeDest: number
) {
    return Controller(
        GetConfigEnvelopeDestinatarioService(idConfigEnvelopeDest)
    );
}

export async function ListarConfigEnvelopeDestinatarioController(
    idConfigEnvelope: number
) {
    return Controller(
        ListarConfigEnvelopeDestinatarioService(idConfigEnvelope)
    );
}

export async function InserirConfigEnvelopeDestinatarioController(
    configEnvelope: IInserirConfigEnvelopeDestinatario
) {
    return Controller(InserirConfigEnvelopeDestinatarioService(configEnvelope));
}

export async function DeletarConfigEnvelopeDestinatarioController(
    idConfigEnvelope: number
) {
    return Controller(
        DeletarConfigEnvelopeDestinatarioService(idConfigEnvelope)
    );
}

export async function AtualizarConfigEnvelopeDestinatarioController(
    configEnvelope: IConfigEnvelopeDestinatario
) {
    return Controller(
        AtualizarConfigEnvelopeDestinatarioService(configEnvelope)
    );
}
